var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"content-wrapper empty:hidden"},[(_vm.hasSlotContent)?_c('section',{staticClass:"max-w-[1920px] bg-gray-50 mx-auto"},[_c('BaseGridLayout',[_c('div',{staticClass:"related-content-wrapper col-span-12 flex flex-wrap justify-center gap-6 empty:hidden"},[_vm._t("default")],2)])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }